<div class="repayments-wrapper">
  <!-- [ngStyle]="{ 'padding-top': showAll ? '0' : '12px' }" -->
  <div *ngIf="canView && showAll" class="quick-filter-container">
    <div class="quick-filter-controls">
      <div
        class="quick-filter-selector"
        (click)="toggleQuickFilterPopover('merchant', merchantPopover, $event)"
      >
        <i class="pi pi-shop"></i>
        <span class="quick-filter-text">Merchants</span>
        <span
          class="quick-filter-count-slot"
          [class.quick-filter-count-slot-hidden]="
            getQuickFilterCount('merchant') === 0
          "
          style="display: inline-flex; flex: 0 0 auto"
        >
          <span
            class="p-badge p-component p-badge-info selected-count quick-filter-count"
            [class.quick-filter-count-hidden]="
              getQuickFilterCount('merchant') === 0
            "
            style="
              display: inline-flex;
              align-items: center;
              justify-content: center;
              min-width: 1.15rem;
              padding: 1px 6px;
              background-color: var(--p-badge-info-background, #007ad9);
              color: #fff;
              border-radius: 999px;
            "
          >
            <span class="count-number">{{
              getQuickFilterCount('merchant')
            }}</span>
          </span>
        </span>
        <i class="pi pi-chevron-down quick-filter-icon"></i>
        <p-popover
          #merchantPopover
          [dismissable]="false"
          (onShow)="onQuickFilterPopoverShow('merchant', merchantPopover)"
          (onHide)="onQuickFilterPopoverHide('merchant')"
        >
          <div class="quick-filter-popover" (click)="$event.stopPropagation()">
            <input
              pInputText
              type="text"
              class="quick-filter-search-input"
              placeholder="Search merchants"
              [ngModel]="merchantSearch.term"
              (ngModelChange)="onQuickFilterSearchInput('merchant', $event)"
              (click)="$event.stopPropagation()"
            />
            @if (
              getQuickFilterState('merchant').loading &&
              getQuickFilterState('merchant').term.trim()
            ) {
              <div
                class="p-listbox-option quick-filter-loading-option"
                aria-hidden="true"
              >
                <span
                  class="quick-filter-status-checkbox-spacer"
                  aria-hidden="true"
                >
                  <i class="pi pi-spin pi-spinner"></i>
                </span>
                <span
                  class="quick-filter-loading-label"
                  style="padding-left: 0.75rem"
                  >Searching...</span
                >
              </div>
            } @else if (getQuickFilterOptions('merchant').length > 0) {
              <p-listbox
                [multiple]="false"
                [checkbox]="false"
                [showToggleAll]="false"
                [options]="getQuickFilterOptions('merchant')"
                [ngModel]="selectedMerchants[0] ?? null"
                optionLabel="name"
                dataKey="name"
                class="quick-filter-listbox"
                [listStyle]="{ 'max-height': '16rem' }"
                (ngModelChange)="onMerchantQuickFilterModelChange($event)"
                (click)="$event.stopPropagation()"
              />
              @if (getQuickFilterState('merchant').loadingMore) {
                <div
                  class="p-listbox-option quick-filter-loading-option"
                  aria-hidden="true"
                >
                  <span
                    class="quick-filter-status-checkbox-spacer"
                    aria-hidden="true"
                  >
                    <i class="pi pi-spin pi-spinner"></i>
                  </span>
                  <span
                    class="quick-filter-loading-label"
                    style="padding-left: 0.75rem"
                    >Loading more...</span
                  >
                </div>
              }
            } @else {
              @if (getQuickFilterState('merchant').loading) {
                <div
                  class="p-listbox-option quick-filter-loading-option"
                  aria-hidden="true"
                >
                  <span
                    class="quick-filter-status-checkbox-spacer"
                    aria-hidden="true"
                  >
                    <i class="pi pi-spin pi-spinner"></i>
                  </span>
                  <span
                    class="quick-filter-loading-label"
                    style="padding-left: 0.75rem"
                    >Loading options...</span
                  >
                </div>
              } @else {
                <div class="quick-filter-status">
                  <span>{{ getQuickFilterEmptyMessage('merchant') }}</span>
                </div>
              }
            }
          </div>
        </p-popover>
      </div>
      <div
        class="quick-filter-selector"
        (click)="toggleQuickFilterPopover('terminal', terminalPopover, $event)"
      >
        <i class="pi pi-credit-card"></i>
        <span class="quick-filter-text">Terminals</span>
        <span
          class="quick-filter-count-slot"
          [class.quick-filter-count-slot-hidden]="
            getQuickFilterCount('terminal') === 0
          "
          style="display: inline-flex; flex: 0 0 auto"
        >
          <span
            class="p-badge p-component p-badge-info selected-count quick-filter-count"
            [class.quick-filter-count-hidden]="
              getQuickFilterCount('terminal') === 0
            "
            style="
              display: inline-flex;
              align-items: center;
              justify-content: center;
              min-width: 1.15rem;
              padding: 1px 6px;
              background-color: var(--p-badge-info-background, #007ad9);
              color: #fff;
              border-radius: 999px;
            "
          >
            <span class="count-number">{{
              getQuickFilterCount('terminal')
            }}</span>
          </span>
        </span>
        <i class="pi pi-chevron-down quick-filter-icon"></i>
        <p-popover
          #terminalPopover
          [dismissable]="false"
          (onShow)="onQuickFilterPopoverShow('terminal', terminalPopover)"
          (onHide)="onQuickFilterPopoverHide('terminal')"
        >
          <div class="quick-filter-popover" (click)="$event.stopPropagation()">
            <input
              pInputText
              type="text"
              class="quick-filter-search-input"
              placeholder="Search terminals"
              [ngModel]="terminalSearch.term"
              (ngModelChange)="onQuickFilterSearchInput('terminal', $event)"
              (click)="$event.stopPropagation()"
            />
            @if (
              getQuickFilterState('terminal').loading &&
              getQuickFilterState('terminal').term.trim()
            ) {
              <div
                class="p-listbox-option quick-filter-loading-option"
                aria-hidden="true"
              >
                <span
                  class="quick-filter-status-checkbox-spacer"
                  aria-hidden="true"
                >
                  <i class="pi pi-spin pi-spinner"></i>
                </span>
                <span
                  class="quick-filter-loading-label"
                  style="padding-left: 0.75rem"
                  >Searching...</span
                >
              </div>
            } @else if (getQuickFilterOptions('terminal').length > 0) {
              <p-listbox
                [multiple]="true"
                [checkbox]="true"
                [showToggleAll]="false"
                [options]="getQuickFilterOptions('terminal')"
                [(ngModel)]="selectedTerminals"
                optionLabel="name"
                dataKey="name"
                class="quick-filter-listbox"
                [listStyle]="{ 'max-height': '16rem' }"
                (onChange)="onQuickFilterSelectionChange('terminal')"
                (click)="$event.stopPropagation()"
              />
              @if (isQuickFilterContextPending('terminal')) {
                <div
                  class="p-listbox-option quick-filter-loading-option"
                  aria-hidden="true"
                >
                  <span
                    class="quick-filter-status-checkbox-spacer"
                    aria-hidden="true"
                  >
                    <i class="pi pi-spin pi-spinner"></i>
                  </span>
                  <span
                    class="quick-filter-loading-label"
                    style="padding-left: 0.75rem"
                    >Loading options...</span
                  >
                </div>
              }
              @if (getQuickFilterState('terminal').loadingMore) {
                <div
                  class="p-listbox-option quick-filter-loading-option"
                  aria-hidden="true"
                >
                  <span
                    class="quick-filter-status-checkbox-spacer"
                    aria-hidden="true"
                  >
                    <i class="pi pi-spin pi-spinner"></i>
                  </span>
                  <span
                    class="quick-filter-loading-label"
                    style="padding-left: 0.75rem"
                    >Loading more...</span
                  >
                </div>
              }
            } @else {
              @if (getQuickFilterState('terminal').loading) {
                <div
                  class="p-listbox-option quick-filter-loading-option"
                  aria-hidden="true"
                >
                  <span
                    class="quick-filter-status-checkbox-spacer"
                    aria-hidden="true"
                  >
                    <i class="pi pi-spin pi-spinner"></i>
                  </span>
                  <span
                    class="quick-filter-loading-label"
                    style="padding-left: 0.75rem"
                    >Loading options...</span
                  >
                </div>
              } @else {
                <div class="quick-filter-status">
                  <span>{{ getQuickFilterEmptyMessage('terminal') }}</span>
                </div>
              }
            }
          </div>
        </p-popover>
      </div>
      <div
        class="quick-filter-selector"
        (click)="
          toggleQuickFilterPopover('cashAdvance', cashAdvancePopover, $event)
        "
      >
        <i class="pi pi-pound"></i>
        <span class="quick-filter-text">Cash Advances</span>
        <span
          class="quick-filter-count-slot"
          [class.quick-filter-count-slot-hidden]="
            getQuickFilterCount('cashAdvance') === 0
          "
          style="display: inline-flex; flex: 0 0 auto"
        >
          <span
            class="p-badge p-component p-badge-info selected-count quick-filter-count"
            [class.quick-filter-count-hidden]="
              getQuickFilterCount('cashAdvance') === 0
            "
            style="
              display: inline-flex;
              align-items: center;
              justify-content: center;
              min-width: 1.15rem;
              padding: 1px 6px;
              background-color: var(--p-badge-info-background, #007ad9);
              color: #fff;
              border-radius: 999px;
            "
          >
            <span class="count-number">{{
              getQuickFilterCount('cashAdvance')
            }}</span>
          </span>
        </span>
        <i class="pi pi-chevron-down quick-filter-icon"></i>
        <p-popover
          #cashAdvancePopover
          [dismissable]="false"
          (onShow)="onQuickFilterPopoverShow('cashAdvance', cashAdvancePopover)"
          (onHide)="onQuickFilterPopoverHide('cashAdvance')"
        >
          <div class="quick-filter-popover" (click)="$event.stopPropagation()">
            <input
              pInputText
              type="text"
              class="quick-filter-search-input"
              placeholder="Search cash advances"
              [ngModel]="cashAdvanceSearch.term"
              (ngModelChange)="onQuickFilterSearchInput('cashAdvance', $event)"
              (click)="$event.stopPropagation()"
            />
            @if (
              getQuickFilterState('cashAdvance').loading &&
              getQuickFilterState('cashAdvance').term.trim()
            ) {
              <div
                class="p-listbox-option quick-filter-loading-option"
                aria-hidden="true"
              >
                <span
                  class="quick-filter-status-checkbox-spacer"
                  aria-hidden="true"
                >
                  <i class="pi pi-spin pi-spinner"></i>
                </span>
                <span
                  class="quick-filter-loading-label"
                  style="padding-left: 0.75rem"
                  >Searching...</span
                >
              </div>
            } @else if (getQuickFilterOptions('cashAdvance').length > 0) {
              <p-listbox
                [multiple]="true"
                [checkbox]="true"
                [showToggleAll]="false"
                [options]="getQuickFilterOptions('cashAdvance')"
                [(ngModel)]="selectedCashAdvances"
                optionLabel="name"
                dataKey="name"
                class="quick-filter-listbox"
                [listStyle]="{ 'max-height': '16rem' }"
                (onChange)="onQuickFilterSelectionChange('cashAdvance')"
                (click)="$event.stopPropagation()"
              >
                <ng-template pTemplate="item" let-cashAdvance>
                  <span
                    class="cash-advance-status-dot"
                    [class.cash-advance-status-dot-active]="
                      cashAdvance.activeCashAdvance
                    "
                    [class.cash-advance-status-dot-inactive]="
                      !cashAdvance.activeCashAdvance
                    "
                    [attr.aria-label]="
                      cashAdvance.activeCashAdvance
                        ? 'Active cash advance'
                        : 'Inactive cash advance'
                    "
                    [pTooltip]="
                      cashAdvance.activeCashAdvance ? 'Active' : 'Inactive'
                    "
                    tooltipPosition="right"
                  ></span>
                  <span>{{ cashAdvance.name }}</span>
                </ng-template>
              </p-listbox>
              @if (isQuickFilterContextPending('cashAdvance')) {
                <div
                  class="p-listbox-option quick-filter-loading-option"
                  aria-hidden="true"
                >
                  <span
                    class="quick-filter-status-checkbox-spacer"
                    aria-hidden="true"
                  >
                    <i class="pi pi-spin pi-spinner"></i>
                  </span>
                  <span
                    class="quick-filter-loading-label"
                    style="padding-left: 0.75rem"
                    >Loading options...</span
                  >
                </div>
              }
              @if (getQuickFilterState('cashAdvance').loadingMore) {
                <div
                  class="p-listbox-option quick-filter-loading-option"
                  aria-hidden="true"
                >
                  <span
                    class="quick-filter-status-checkbox-spacer"
                    aria-hidden="true"
                  >
                    <i class="pi pi-spin pi-spinner"></i>
                  </span>
                  <span
                    class="quick-filter-loading-label"
                    style="padding-left: 0.75rem"
                    >Loading more...</span
                  >
                </div>
              }
            } @else {
              @if (getQuickFilterState('cashAdvance').loading) {
                <div
                  class="p-listbox-option quick-filter-loading-option"
                  aria-hidden="true"
                >
                  <span
                    class="quick-filter-status-checkbox-spacer"
                    aria-hidden="true"
                  >
                    <i class="pi pi-spin pi-spinner"></i>
                  </span>
                  <span
                    class="quick-filter-loading-label"
                    style="padding-left: 0.75rem"
                    >Loading options...</span
                  >
                </div>
              } @else {
                <div class="quick-filter-status">
                  <span>{{ getQuickFilterEmptyMessage('cashAdvance') }}</span>
                </div>
              }
            }
          </div>
        </p-popover>
      </div>
    </div>
    @if (getAppliedQuickFilterPills().length > 0) {
      <div class="quick-filter-applied">
        <div class="quick-filter-divider" aria-hidden="true"></div>
        @for (
          pill of getAppliedQuickFilterPills();
          track pill.kind + ':' + pill.label
        ) {
          <div class="applied-filter-pill-wrap">
            <button
              type="button"
              class="applied-filter-pill"
              [class.applied-filter-pill-hovered]="
                isAppliedQuickFilterHovered(pill.kind, pill.label)
              "
              [style.width.px]="
                getAppliedQuickFilterHoverWidth(pill.kind, pill.label)
              "
              (click)="$event.preventDefault()"
              (mouseenter)="
                onAppliedQuickFilterHoverStart(pill.kind, pill.label, $event)
              "
              (mouseleave)="onAppliedQuickFilterHoverEnd(pill.kind, pill.label)"
              style="
                position: relative;
                display: grid;
                grid-template-columns: auto minmax(0, 1fr);
                column-gap: 0.375rem;
                max-width: 140px;
                overflow: hidden;
                padding: 0 0.55rem;
                color: color-mix(
                  in srgb,
                  var(--p-tabs-tab-color) 84%,
                  #fff 16%
                );
                background: rgba(255, 255, 255, 0.04);
                border-color: color-mix(
                  in srgb,
                  var(--p-tabs-tab-color) 30%,
                  transparent
                );
              "
            >
              <span
                class="applied-filter-icon"
                style="
                  display: inline-flex;
                  align-items: center;
                  align-self: center;
                  line-height: 1;
                "
              >
                <i [class]="pill.icon"></i>
              </span>
              <span
                class="applied-filter-text"
                style="
                  display: inline-flex;
                  align-items: center;
                  width: 100%;
                  min-width: 0;
                  max-width: 100%;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                "
                >{{ pill.label }}</span
              >
              <span
                class="applied-filter-remove-slot"
                style="
                  position: absolute;
                  top: 50%;
                  right: 0.5rem;
                  width: 0.7rem;
                  height: 0.7rem;
                  transform: translateY(-50%);
                "
              >
                <span
                  class="applied-filter-remove"
                  style="
                    position: absolute;
                    inset: 0;
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                  "
                  pTooltip="Remove filter"
                  tooltipPosition="bottom"
                  (click)="removeQuickFilterPill(pill.kind, pill.label, $event)"
                >
                  <i class="pi pi-times"></i>
                </span>
              </span>
            </button>
          </div>
        }
      </div>
    }
  </div>
  <div class="selected-file" *ngIf="canView && !showAll && !embedded">
    <p-table
      #headerTable
      [value]="[sourceFile]"
      [(selection)]="sourceFile"
      dataKey="id"
      [globalFilterFields]="[
        'name',
        'date',
        'source',
        'status',
        'repayment_count',
      ]"
      ><ng-template #body let-file *ngIf="sourceFile; else loadingBody">
        <uploaded-file-row #uploadedFileRow />
        <!-- Use row template and pass the buttons template in the context. -->
        <ng-container
          *ngTemplateOutlet="
            uploadedFileRow.row;
            context: {
              onFileClick: onFileClick.bind(this),
              $implicit: sourceFile,
              expandedRow: sourceFile?.id,
              buttonTemplate: sourceFileButtonTemplate,
              buttonTemplateContext: { $implicit: sourceFile },
            }
          "
        ></ng-container>
      </ng-template>
      <ng-template #loadingBody pTemplate="loadingbody">
        <tr>
          <td *ngFor="let col of [1, 2, 3, 4, 5, 6]">
            <p-skeleton styleClass="w-full h-1.5rem" />
          </td>
        </tr>
      </ng-template>
    </p-table>
    <ng-template #sourceFileButtonTemplate let-file>
      <button
        pButton
        pRipple
        type="button"
        icon="pi pi-save"
        (click)="saveSourceFile($event, file)"
        [loading]="isCommittingSourceFile(file)"
        [disabled]="
          isCommittingSourceFile(file) ||
          isSourceFileSaved(file) ||
          hasPendingTableChanges()
        "
        text
        rounded
        severity="success"
        [pTooltip]="
          hasPendingTableChanges()
            ? 'Use Commit all to Salesforce to save the edited repayments'
            : isSourceFileSaved(file)
              ? 'Already saved to repayments'
              : 'Commit to Salesforce'
        "
        tooltipPosition="bottom"
      ></button>
      <span *ngIf="isCommittingSourceFile(file)" class="commit-progress">
        {{ sourceFileCommitProgressPercent(file) }}%
      </span>
    </ng-template>
  </div>
  <p-toast />
  <repayments-table
    *ngIf="canView && (!sourceFileId || sourceFile)"
    [repayments]="repayments"
    [dataTable]="dataTable"
    [sourceFileId]="sourceFileId"
    [sourceFileStatus]="sourceFile?.status ?? null"
    [fileRepaymentsCount]="sourceFile?.repayment_count ?? null"
    [loading]="loading"
    [totalRepaymentsCount]="repaymentsTotal"
    [isInProgress]="currentPage === 'in-progress'"
    [canView]="canView"
    [canEdit]="canEdit"
    [canDelete]="canDelete"
    (pendingChangesChanged)="onPendingChangesChanged($event)"
    (scrolledToBottom)="onRepaymentsScrolledToBottom()"
  ></repayments-table>
  <div *ngIf="!canView" class="p-4">
    <div class="p-4">
      You do not have permission to view repayments. Please contact your
      administrator.
    </div>
  </div>
</div>
